import React, { Component } from "react";
import Lightbox from "react-image-lightbox";

import Aux from "../../../../hoc/Aux/Aux";
import "./Nadzor.css";
import imageSection5_1 from "../../../../img/architektura/Rysunek11.jpg";

const images = [imageSection5_1];

export default class Nadzor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
      imagePadding: 100
    };
  }
  render() {
    const { photoIndex, isOpen } = this.state;

    return (
      <Aux>
        <div className="card-background row p-5">
          <div className="col-md lead mt-3">
            Gdy brak jest czasu:
            <ul>
              <li>organizację budowy</li>
              <li>wielokrotne konsultacje</li>
              <li>odbiór wykonanych prac budowlanych</li>
            </ul>
          </div>
          <div className="col-md lead mt-3">
            Warto mieć nadzór:
            <ul>
              <li>zgodność projektu z realizacją</li>
              <li>pewność co do jakość i zakresu usługi</li>
              <li>rozwiązywanie powstałych problemów</li>
            </ul>
          </div>
          <div className="col-md lead mt-3">
            Nadzór:
            <ul>
              <li>jest pełny przy naszym wykonawstwie</li>
              <li>w cenie projektu / 5 spotkań z zewnętrznymi firmami</li>
            </ul>
          </div>
          <div className="row pt-4">
            <div className="image-lightbox col-lg-4 m-auto p-1 border border-dark rounded">
              <img
                src={imageSection5_1}
                alt=""
                className="img-fluid"
                onClick={() => this.setState({ isOpen: true, photoIndex: 0 })}
              />
            </div>
          </div>
        </div>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            onCloseRequest={() => this.setState({ isOpen: false })}
          />
        )}
      </Aux>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Architecture/Services/Nadzor/Nadzor.js